import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import LoginPage from './pages/LoginPage';
import SimpleLayout from './layouts/simple';
import DashboardLayout from './layouts/dashboard';
//
import BlogPage from './pages/BlogPage';
import UserPage from './pages/UserPage';
import Page404 from './pages/Page404';
import ProductsPage from './pages/ProductsPage';
import Alert from './pages/alert/index.js';
import AlertDetail from './pages/alertdetail/[id]';
import Rule from './pages/rule';
import Report from './pages/report';
import Activated from './pages/activated';
import Watchlist from './pages/watchlist';
import DashboardAppPage from './pages/DashboardAppPage';
import AddRule from './pages/add/addrule';
import ViewRule from './pages/view/viewrule';
import AddWatchlist from './pages/add/addwatchlist';
import Information from './pages/information';
import AlertDetails from './pages/view/viewalert';
import Actions from './pages/action';
import ActivityLog from './pages/activitylogs';
import AddUser from './pages/add/adduser';
import EditUser from './pages/user/edit';
import EditAction from './pages/action/edit';
import AddAction from './pages/action/add';
import SignUp from './pages/SignUp';
import Calendar from './pages/calendar';
import Rollback from './pages/rollback';
import Summary from './pages/summary';
import Approval from './pages/approval';
import DetailAlert from './pages/alert/detail-alert';
import Data from './pages/dataset';
import Reset from './pages/Reset';
import LoadingPage from './pages/loadingpage';
import ProtectedRoute from './utils/protectedroute';

// ----------------------------------------------------------------------

export default function Router() {
  const routes = useRoutes([
    {
      path: 'login',
      element: <LoginPage />,
      children: [{ element: <Navigate to="/welcome" />, index: true }],
    },

    {
      path: '/dashboard',
      element: (
        <ProtectedRoute>
          <DashboardLayout />,
        </ProtectedRoute>
      ),
      children: [
        { path: 'app', element: <DashboardAppPage /> },
        { path: 'user', element: <UserPage /> },
        { path: 'products', element: <ProductsPage /> },
        { path: 'blog', element: <BlogPage /> },
        { path: 'rule', element: <Rule /> },
        { path: 'alert', element: <Alert /> },
        { path: 'watchlist', element: <Watchlist /> },
        { path: 'report', element: <Report /> },
        { path: 'dataset', element: <Data /> },
        { path: 'addrule', element: <AddRule /> },
        { path: 'viewrule', element: <ViewRule /> },
        { path: 'addwatchlist', element: <AddWatchlist /> },
        { path: 'information', element: <Information /> },
        { path: 'alertdetail', element: <AlertDetails /> },
        { path: 'action', element: <Actions /> },
        { path: 'activitylogs', element: <ActivityLog /> },
        { path: 'adduser', element: <AddUser /> },
        { path: 'action/add', element: <AddAction /> },
        { path: 'alertdetail/:id', element: <AlertDetail /> },
        { path: 'user/edit', element: <EditUser /> },
        { path: 'action/edit', element: <EditAction /> },
        { path: 'calendar', element: <Calendar /> },
        { path: 'rollback', element: <Rollback /> },
        { path: 'summary', element: <Summary /> },
        { path: 'about', element: <Approval /> },
        { path: 'alert/detail-alert', element: <DetailAlert /> },
      ],
    },

    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to="/login" />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to="/404" /> },
        { path: 'activated', element: <Activated /> },
        { path: 'signup', element: <SignUp /> },
        { path: 'password/reset', element: <Reset /> },
        { path: 'welcome', element: <LoadingPage /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to="/404" replace />,
    },
  ]);

  return routes;
}
